import { Number, Record, Static, String } from 'runtypes'
import { GroupItem } from '@entities/goods/contract'

export const FilterGroup = Record({
    id: Number,
    name: String,
    sortOrder: Number
})

export type IFilterGroup = Static<typeof FilterGroup>
